module.exports = __webpack_public_path__ + "img/btn_apple.3f74fceb.svg";